import React, { useEffect, useState } from 'react'
import { Form, Modal, Spin, Typography } from 'antd'
import { enableMFA, getMFAQRCore } from '../../../api/mfa'
import MaskedInput from 'antd-mask-input'

export enum ModalType {
	DISABLE,
	ENABLE
}

export interface IMFAModalProps {
	close: (type: ModalType, result?: boolean) => void
	visible: boolean
}

export const MfaEnableModal = (props: IMFAModalProps): React.ReactElement => {
	const [loading, setIsLoading] = useState(false)
	const [form] = Form.useForm<{ code: string }>()

	const [qrCode, setQRCode] = useState({
		success: false,
		message: '',
		image: ''
	})

	const [answer, setAnswer] = useState({ success: false, message: '' })

	async function enableMFAHandler() {
		const res = await enableMFA(form.getFieldsValue().code)

		setIsLoading(false)
		if (res.success) {
			form.resetFields()
			setAnswer({ success: false, message: '' })
			setQRCode({ success: false, message: '', image: '' })
			props.close(ModalType.ENABLE, true)
		} else {
			setAnswer(res)
		}
	}

	async function getQRCode() {
		const result = await getMFAQRCore()
		setQRCode(result)
		setIsLoading(false)
	}

	useEffect(() => {
		if (props.visible) {
			void getQRCode()
		}
	}, [props.visible])

	return (
		<Modal
			title="Включение двухфакторной авторизации"
			visible={props.visible}
			onCancel={() => {
				if (!loading) {
					props.close(ModalType.ENABLE, false)
				}
			}}
			onOk={() => {
				setIsLoading(true)
				void enableMFAHandler()
			}}
			okButtonProps={{
				loading,
				type: 'primary'
			}}
			cancelButtonProps={{
				disabled: loading,
				type: 'ghost'
			}}

			okText="Включить"
			cancelText="Закрыть"
			closable={!loading}
		>
			<Typography.Title level={5}>
				Двухфакторная авторизация - гарант безопасности вашего аккаунта.
			</Typography.Title>

			<Typography>
				Чтобы включить её, вам потребуется:
			</Typography>
			<Typography>
				1) Убедиться, что время на телефоне и ПК совпадает
			</Typography>
			<Typography>
				2) Включить синхронизацию времени с интернетом
			</Typography>
			<Typography>
				3) Отсканировать QR код с помощью Google Authenticator, и ввести полученные цифры ниже.
			</Typography>

			{
				loading && qrCode.success ?
					<Spin style={{ margin: '3%' }} size="default"/>
					:
					<img
						src={`data:image/png;base64,${qrCode.image}`}
						style={{
							width: '40%',
							height: '40%',

							margin: '3% auto',
							display: 'block',
						}}
						alt="qr code"
					/>
			}

			{answer ? (
				<Typography style={{ color: 'red', margin: '2% 0' }}>
					{answer.message}
				</Typography>
			) : <></>}

			<Form form={form} layout="vertical">
				<Form.Item label="Код двухфакторной авторизации" name="code">
					<MaskedInput mask="111 111"/>
				</Form.Item>
			</Form>
		</Modal>
	)
}
